var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gb-eng",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1124",
    d: "M215 0h82v512h-82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1124",
    d: "M0 215h512v82H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbEng);
export default __webpack_public_path__ + "static/media/gb-eng.7b249f565cc9aa70b36bcdee11fd25e0.svg";
export { ForwardRef as ReactComponent };